var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6369 0.35708C14.121 0.841395 14.121 1.62123 13.6369 2.09733L10.4451 5.29053L12.1846 12.8344L11.0277 14L7.8441 7.90091L4.6441 11.1023L4.93949 13.1299L4.06154 14L2.61744 11.3896L0 9.93668L0.869744 9.05013L2.92103 9.35385L6.09641 6.17707L0 2.96746L1.16513 1.81003L8.70564 3.55028L11.8974 0.35708C12.3569 -0.119027 13.1774 -0.119027 13.6369 0.35708Z",
    fill: "#27346A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.6ebfc9b115cb8d2c5c8e8d4ee5fa27ca.svg";
export { ForwardRef as ReactComponent };